export default __webpack_public_path__ + "static/media/6.f7eaed68.png";